import ShareAuth from '@sagano/share/vendors/firebase';
import { auth } from '@sagano/admin/stores';

const adminAuth = new ShareAuth(auth);

export const storage = adminAuth.storage;
export default adminAuth;
